"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Auto.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Auto = function Auto(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 126.4 205.46"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Automatic Engine Logo"), _react2.default.createElement("g", {
    className: "automatic",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M66.36 36.33V3.16a3.16 3.16 0 0 0-6.32 0v33.17a63.22 63.22 0 0 0 0 126.28v39.69a3.16 3.16 0 0 0 6.32 0v-39.69a63.22 63.22 0 0 0 0-126.28zm-3.16 120a56.9 56.9 0 1 1 56.9-56.9 56.9 56.9 0 0 1-56.86 56.94z",
    className: "gearbox",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M86.22 121.31h-5.15a2.21 2.21 0 0 1-1.44-.45 2.73 2.73 0 0 1-.82-1.13l-4.6-11.87H52.15l-4.6 11.87a2.41 2.41 0 0 1-.79 1.1 2.19 2.19 0 0 1-1.44.48h-5.14l19.66-49.16h6.72zm-13.86-18.25l-7.72-20q-.34-.89-.72-2.08t-.72-2.52a37.39 37.39 0 0 1-1.48 4.63l-7.72 20h18.36z",
    className: "letter",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = Auto;